{
  "logoAlt": "Smart Word Labs",
  "footer": {
    "copyright": "© {{year}} Smart Word Labs · {{tagline}}"
  },
  "breadcrumb": {
    "home": "الرئيسية",
    "ariaLabel": "مسار التنقل"
  },
  "notifications": {
    "ariaLabel": "الإشعارات",
    "unreadMore": "+9",
    "title": "التنبيهات",
    "markRead": "تعليم كمقروء",
    "new": "جديد",
    "empty": "لا توجد تنبيهات بعد.",
    "error": "تعذر تحديث الإشعارات"
  },
  "mobileCta": {
    "bookFreeAssessment": "احجز تقييمًا مجانيًا"
  }
}
